module.exports = __webpack_public_path__ + "static/media/btn2.33095fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/btn2.png
// module id = 1503
// module chunks = 0